import React from 'react'
import { TextField } from 'components/Form'
import PropTypes from 'prop-types'

export default function CurrencyField({ onChange, value, ...props }) {
  const handleChange = event => {
    const { value, id, name } = event.target
    const newValue = value.trim().replace(',', '.')

    if (!isNaN(newValue)) {
      onChange({ target: { id, name, value: newValue } })
    }
  }

  return <TextField {...props} value={value} suffix="EUR" onChange={handleChange} />
}

CurrencyField.propTypes = {
  name: PropTypes.string,
  id: PropTypes.string,
  value: PropTypes.any,
  onChange: PropTypes.func,
}



// WEBPACK FOOTER //
// ./src/components/Form/CurrencyField/CurrencyField.js